import { State } from '../../type'
import { moduleName } from './constants'
import { ISetPasswordData } from './types'

const getState = (state: State): ISetPasswordData => state[moduleName]

export const getPasswordData = (state: State) => getState(state)
